import React from "react";
import { useProfilePanelData } from "./hooks/useProfilePanelData";
import { BasicVerificationModal, SecurityCard, Settings } from "@housebets/housebets-x-package";
import { useIntl } from "react-intl";
import { BaseVerificationForm } from "../forms";
import { useGTMEvents } from "app/hooks/useGTMEvents";

export const ProfilePanel: React.FC = (props) => {
    const {
        updateNick,
        userData,
        isModalOpen,
        setIsModalOpen,
        verified,
        setIsVerified
    } = useProfilePanelData();
    const { $t } = useIntl();
    const { modal } = useGTMEvents();

    return (
        <Settings.ProfilePanel.PPanel {...props}>
            <Settings.ProfilePanel.PRow noPaddingTop>
                <Settings.User
                    onEdit={updateNick}
                    data={userData}
                />
            </Settings.ProfilePanel.PRow>

            <Settings.ProfilePanel.PRow>
                <Settings.EmailVerification
                    email={userData.email}
                    verified={userData.email_verified}
                />
            </Settings.ProfilePanel.PRow>

            <Settings.ProfilePanel.PList>
                <div>
                    <Settings.ProfilePanel.PTitle>
                        {$t({ id: 'AccountVerification' })}
                    </Settings.ProfilePanel.PTitle>

                    <Settings.ProfilePanel.Description>
                        {$t({ id: 'AccountVerification1' }, { Br: <br /> })}
                    </Settings.ProfilePanel.Description>
                </div>

                <SecurityCard
                    title={$t({ id: 'BasicInformation' })}
                    text={
                        <>
                            {$t({ id: 'BasicInformationDesc' })}.{' '}
                        </>
                    }
                    submitButtonText={$t({ id: 'VerifyNow' })}
                    verifiedButtonText={$t({ id: 'Connected' })}
                    lightTextColor
                    titleBorder
                    titleWithBadge
                    verificationTime={$t({ id: 'ReviewTimeFewMins' })}
                    onClick={() => {
                        setIsModalOpen(true)
                    }}
                    verified={verified}
                />

                {/* <SecurityCard
                    title="Advanced Verification"
                    text={<>Upload a copy of your ID</>}
                    submitButtonText="Verify now"
                    verifiedButtonText="Connected"
                    lightTextColor
                    titleBorder
                    titleWithBadge
                    verificationTime="10D"
                    onClick={() => { }}
                    verified={false}
                /> */}
            </Settings.ProfilePanel.PList>
            <BasicVerificationModal
                isOpen={isModalOpen}
                onClose={() => {
                    setIsModalOpen(false)
                }}
                afterOpenModal={() => {
                    modal.show('basic_verification')
                }}
                onAfterClose={() => {
                    modal.close('basic_verification')
                }}
            >
                <BaseVerificationForm
                    onSubmit={() => {
                        setIsVerified(true);
                        setIsModalOpen(false);
                    }}
                />
            </BasicVerificationModal>
        </Settings.ProfilePanel.PPanel>
    )
}

ProfilePanel.displayName = 'ProfilePanel'